import { CSSObject } from '@emotion/react';

export const styleSheetReset: CSSObject = {
    '*': {
        boxSizing: 'border-box',
    },
    html: {
        height: '100%',
        margin: 0,
        padding: 0,
    },
    body: {
        height: '100%',
        margin: 0,
        padding: 0,
    },
    img: {
        maxWidth: '100%',
        maxHeight: '100%',
        display: 'block',
    },
    scrollbarColor: '#6b6b6b #2b2b2b',
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
        backgroundColor: '#2b2b2b',
    },
    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
        borderRadius: 8,
        backgroundColor: '#6b6b6b',
        minHeight: 24,
        border: '3px solid #2b2b2b',
    },
    '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
        backgroundColor: '#959595',
    },
    '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
        backgroundColor: '#959595',
    },
    '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#959595',
    },
    '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
        backgroundColor: '#2b2b2b',
    },
};
